export default {
    setStoryTags: (state, param) => {
        const {payload} = param;
        return state.data = payload;
    },
    setStoryTag: (state, param) => {
        const {payload} = param;
        state.data[payload.id] = payload
    },
    clearFilters: (state) => {
        state.queryParams = {perPage: 25, page: 1}
    }
}
